/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
  Box,
  Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import api from '../utils/functions/api';
import TableHistorySuperAdmin from '../components/TableHistorySuperAdmin';
import { getStorage } from '../utils/functions/localstorage';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SpeedDial from '@mui/material/SpeedDial';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Loading from '../components/Loading';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function HistorySuperAdmin() {
  const [allData, setAllData] = useState([]);
  const [ishistorySuperAdmin, setIShistorySuperAdmin] = useState([]);
  const [allHistorySuperAdmin, setAllHistorySuperAdmin] = useState([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [startDateFilter, setStartDateFilter] = useState(
    dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
  );
  const [endDateFilter, setEndDateFilter] = useState(
    dayjs().format('YYYY-MM-DD'),
  );
  const [orderDirection, setOrderDirection] = useState('asc');
  const [valueToOrderBy, setValueToOrderBy] = useState('');
  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    lastPage: 1,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMerchants, setSelectedMerchants] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]); // New state for selected status
  const [merchOpt, setMerchOpt] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [statusOptions, setStatusOptions] = useState([
    { label: 'Pending', value: 'pending' },
    { label: 'Success', value: 'success' },
    // { label: 'Reject', value: 'reject' },
    { label: 'Fail', value: 'fail' },
  ]);

  const fetchMerchants = async () => {
    try {
      setIsLoading(true);
      const path = `${process.env.REACT_APP_APIHOST}/company/data/all`;
      const { data } = await api.get(path, {
        headers: { Authorization: getStorage('token') },
      });
      setMerchOpt(data.filter((merchant) => merchant.name));
      setIsLoading(false);
    } catch (e) {
      throw new Error(e);
    }
  };

  const historySuperAdmin = async () => {
    console.log('1', 1);
    try {
      // setIsLoading(true);
      const statusFilter = statusOptions.join(',');
      const mkeyFilter = selectedMerchants.join(',');

      const path = `${
        process.env.REACT_APP_APIHOST
      }/merchant/transaction?startDate=${startDateFilter}&endDate=${endDateFilter}&mkeyfilter=${mkeyFilter}&status=${selectedStatus.join(
        ',',
      )}&search=${searchText}&sort_by=${valueToOrderBy}&order=${orderDirection}`;

      const { data } = await api.get(path, {});
      setAllHistorySuperAdmin(data.data || []); // Ensure allHistoryAdmin is set correctly
      setIShistorySuperAdmin(data.data || []);
      setTotalAmount(data);
      setAllData(data);
      setPagination((prev) => ({
        ...prev,
        total: data.data ? data.data.length : 0, // Use data.data.length
        lastPage: data.data ? Math.ceil(data.data.length / pagination.size) : 1, // Calculate lastPage correctly
      }));
      // setIsLoading(false);
    } catch (e) {
      // setIsLoading(false); // Ensure loading is set to false even on error
      throw new Error(e);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      await historySuperAdmin();
      await fetchMerchants();

      setIsLoading(false);
    };

    fetchData();
  }, []);

  const filterHistory = () => {
    const filteredData = allHistorySuperAdmin.filter((item) => {
      const searchTextLower = searchText.toLowerCase();
      const statusMatch = selectedStatus.length
        ? selectedStatus.includes(item.status)
        : true;
      return (
        statusMatch &&
        ((item.order_id &&
          item.order_id.toLowerCase().includes(searchTextLower)) ||
          (item.ref && item.ref.toLowerCase().includes(searchTextLower)))
      );
    });

    setIShistorySuperAdmin(filteredData);
    setPagination((prev) => ({
      ...prev,
      total: filteredData.length,
      lastPage: Math.ceil(filteredData.length / pagination.size),
    }));
  };

  const handleMerchantChange = (event, newValueMerchant) => {
    if (newValueMerchant) {
      const newMerchantIds = newValueMerchant.map(
        (option) => option.key_cashier,
      );
      setSelectedMerchants(newMerchantIds);
    } else {
      setSelectedMerchants([]);
    }
  };

  const handleStatusChange = (event, newValueStatus) => {
    setSelectedStatus(newValueStatus.map((option) => option.value));
  };

  const handleRequestSort = (event, property) => {
    const isAscending = valueToOrderBy === property && orderDirection === 'asc';
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? 'desc' : 'asc');
  };

  const handlePaginationChange = (event, value) => {
    if (event === 'handleChangePage') {
      setPagination({ ...pagination, currPage: value });
    } else {
      setPagination({ ...pagination, currPage: 1, size: value });
    }
  };

  const onClickSubmit = () => {
    setPagination({ ...pagination, currPage: 1 });
    filterHistory();
    historySuperAdmin();
  };

  const onClickCancel = () => {
    window.location.reload();
  };

  const [direction, setDirection] = React.useState('left');
  const download = [
    { icon: <FontAwesomeIcon icon={faFileExcel} size="xl" />, name: 'EXCLE' },
    { icon: <FontAwesomeIcon icon={faFilePdf} size="xl" />, name: 'PDF' },
  ];

  const prepareDataDownload = async (
    typeDownload,
    valueHeader,
    fileName,
    valueOption,
  ) => {
    setIsLoading(true);
    const headers = { Accept: 'application/json' };
    try {
      let apiUrl = '';
      if (typeDownload === 'pdf') {
        apiUrl = `${process.env.REACT_APP_APIHOST}/merchant/transaction/pdf`;
      } else if (typeDownload === 'csv') {
        apiUrl = `${process.env.REACT_APP_APIHOST}/merchant/transaction/excel`;
      }

      // Make the request to the API
      const response = await api.post(apiUrl, allData, {
        responseType: 'arraybuffer', // Ensure the response is treated as binary data
        headers,
      });

      const now = new Date();
      const day = now.getDate().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const year = now.getFullYear().toString();
      const formattedDate = `${day}-${month}-${year}`;

      const outputFilename = `transaction-report-${formattedDate}.${
        typeDownload === 'pdf' ? 'pdf' : 'xlsx'
      }`;

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type:
          typeDownload === 'pdf'
            ? 'application/pdf'
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      // Create a download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error('Error downloading file:', e);
      throw new Error(e);
    }
  };

  const renderFilterFormHistorySuperAdmin = () => (
    <form>
      <Grid container spacing={3} style={{ marginTop: '8px' }}>
        <Grid container item spacing={3} xs={12}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่เริ่มสร้างรายการ"
                disableFuture
                inputFormat="DD/MM/YYYY"
                value={startDateFilter}
                minDate={dayjs().subtract(10, 'year')}
                maxDate={dayjs().add(10, 'year')}
                onChange={(value) => {
                  setStartDateFilter(dayjs(value).format('YYYY-MM-DD'));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่สิ้นสุดสร้างรายการ"
                disableFuture
                inputFormat="DD/MM/YYYY"
                value={endDateFilter}
                minDate={dayjs().subtract(10, 'year')}
                maxDate={dayjs().add(10, 'year')}
                onChange={(value) => {
                  setEndDateFilter(dayjs(value).format('YYYY-MM-DD'));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Grid container item spacing={3} xs={12}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              size="small"
              options={merchOpt.filter((merchant) => merchant.name)}
              disableCloseOnSelect
              getOptionLabel={(option) => `${option.name}`}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name}
                </li>
              )}
              onChange={handleMerchantChange}
              value={merchOpt.filter((option) =>
                selectedMerchants.includes(option.key_cashier),
              )}
              renderInput={(params) => (
                <TextField {...params} label="ค้นหาร้านค้า :" fullWidth />
              )}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <TextField
              className="text"
              label="ค้นหาข้อความ :"
              variant="outlined"
              size="small"
              fullWidth
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              size="small"
              options={statusOptions} // Filter status options
              disableCloseOnSelect
              getOptionLabel={(option) => `${option.label}`}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
              onChange={handleStatusChange}
              value={statusOptions.filter((option) =>
                selectedStatus.includes(option.value),
              )}
              renderInput={(params) => (
                <TextField {...params} label="ค้นหาสถานะ :" fullWidth />
              )}
            />
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          justifyContent="space-between"
          alignItems="center"
          style={{ marginLeft: '20px' }}
        >
          <Button
            onClick={onClickSubmit}
            variant="outlined"
            color="success"
            size="medium"
            sx={{
              mr: { xs: 0, sm: 2 }, // Margin right สำหรับหน้าจอเล็ก
            }}
          >
            ยืนยัน
          </Button>
          <Button
            onClick={onClickCancel}
            variant="outlined"
            color="error"
            size="medium"
          >
            รีเซ็ต
          </Button>
          <SpeedDial
            ariaLabel="SpeedDial basic example"
            sx={{
              position: 'relative',
              ml: { xs: 0, sm: 'auto' }, // Margin left สำหรับหน้าจอใหญ่
              mr: { xs: 1, sm: 2 }, // Margin right สำหรับหน้าจอใหญ่
            }}
            icon={<FileDownloadIcon sx={{ fontSize: 20 }} />}
            direction={direction}
            FabProps={{
              size: 'small', // ปรับขนาดเป็นเล็ก
              sx: { width: 40, height: 40 }, // ปรับขนาดวงกลม
            }}
          >
            {download &&
              download.map((download) => (
                <SpeedDialAction
                  key={download.name}
                  icon={download.icon}
                  tooltipTitle={download.name}
                  onClick={() => {
                    if (download.name === 'PDF') {
                      prepareDataDownload(
                        'pdf',
                        // fieldPdfTransaction,
                        'Transaction' +
                          dayjs(endDateFilter).format('YYYY-MM-DD'),
                        {
                          0: { halign: 'left' },
                          1: { halign: 'left' },
                          6: { halign: 'right' },
                        },
                      );
                    } else if (download.name === 'EXCLE') {
                      prepareDataDownload(
                        'csv',
                        // fieldCsvTransaction,
                        'Transaction' +
                          dayjs(endDateFilter).format('YYYY-MM-DD'),
                        {
                          0: { halign: 'left' },
                          1: { halign: 'left' },
                          6: { halign: 'right' },
                        },
                      );
                    }
                  }}
                />
              ))}
          </SpeedDial>
        </Grid>
      </Grid>
    </form>
  );

  const sum = () => <div>{totalAmount.total_amount || 0} บาท</div>;
  const count = () => <div>{totalAmount.count || 0} รายการ</div>;
  return (
    <Grid container>
      <Loading isLoading={isLoading} />
      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          ประวัติการทำรายการ
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormHistorySuperAdmin()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
            marginBottom: '10px',
          }}
        >
          <TableHistorySuperAdmin
            ishistorySuperAdmin={ishistorySuperAdmin}
            handleRequestSort={handleRequestSort}
            valueToOrderBy={valueToOrderBy}
            orderDirection={orderDirection}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: { xs: 'flex-end', md: 'flex-end' },
              alignItems: 'center',
              marginRight: { xs: '20px', md: '20px' },
              marginBottom: '40px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: { xs: '0px', md: 0 },
                textAlign: { xs: 'left', md: 'left' },
                width: { xs: '100%', md: 'auto' },
                justifyContent: { xs: 'flex-end', md: 'flex-end' },
              }}
            >
              <Typography sx={{ fontWeight: 'bold', fontSize: '17px' }}>
                จำนวนรายการทั้งหมด
              </Typography>
              <Typography sx={{ marginLeft: '10px', fontSize: '17px' }}>
                {count()}
              </Typography>
            </Box>

            <Box
              sx={{
                marginLeft: { md: '30px', xs: 0 },
                display: 'flex',
                alignItems: 'center',
                textAlign: { xs: 'left', md: 'left' },
                width: { xs: '100%', md: 'auto' },
                justifyContent: { xs: 'flex-end', md: 'flex-end' },
              }}
            >
              <Typography sx={{ fontWeight: 'bold', fontSize: '17px' }}>
                ยอดเงินทั้งหมด
              </Typography>
              <Typography sx={{ marginLeft: '10px', fontSize: '17px' }}>
                {sum()}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      {/* <footer
        style={{
          textAlign: 'right',
          padding: '1px 30px',
          background: '#E7E7E7',
          color: '#838383',
          position: 'fixed',
          left: '0',
          bottom: '0',
          width: '100%',
          borderTop: '1px solid #e7e7e7',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <IconButton
          onClick={() => setIsCounting(!isCounting)}
          variant="contained"
          size="small"
        >
          {isCounting ? <PauseIcon /> : <PlayArrowIcon />}
        </IconButton>
        <AccessTimeIcon />
        {currentTime}
        {''} Refresh in : {counter} sec
      </footer> */}
    </Grid>
  );
}

export default HistorySuperAdmin;
